import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-arrow-left",
  "use": "icon-ic-arrow-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-ic-arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.711 15.893a.833.833 0 0 0 0-1.179L7.997 10l4.714-4.714a.833.833 0 0 0-1.178-1.179L6.229 9.411a.833.833 0 0 0 0 1.178l5.304 5.303a.833.833 0 0 0 1.178 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol